// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-overlay {
  position: fixed;
  inset: 0;
  background: black;
  z-index: 5000;
  pointer-events: none;
  opacity: 0;
}

.animate-screen {
  animation: screenFadeSequence 3s forwards;
}

@keyframes screenFadeSequence {

  /* start */
  0% {
    opacity: 0;
  }

  /* fade in (1.5s) */
  50% {
    opacity: 0.8;
  }

  /* hold black (1s) */
  83.33% {
    opacity: 0.8;
  }

  /* fade out (0.5s) */
  100% {
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/context-module/context-configuration/auth-provider/loadinAni/loadinAni.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,iBAAiB;EACjB,aAAa;EACb,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;EAEE,UAAU;EACV;IACE,UAAU;EACZ;;EAEA,mBAAmB;EACnB;IACE,YAAY;EACd;;EAEA,oBAAoB;EACpB;IACE,YAAY;EACd;;EAEA,oBAAoB;EACpB;IACE,UAAU;EACZ;AACF","sourcesContent":[".loading-overlay {\n  position: fixed;\n  inset: 0;\n  background: black;\n  z-index: 5000;\n  pointer-events: none;\n  opacity: 0;\n}\n\n.animate-screen {\n  animation: screenFadeSequence 3s forwards;\n}\n\n@keyframes screenFadeSequence {\n\n  /* start */\n  0% {\n    opacity: 0;\n  }\n\n  /* fade in (1.5s) */\n  50% {\n    opacity: 0.8;\n  }\n\n  /* hold black (1s) */\n  83.33% {\n    opacity: 0.8;\n  }\n\n  /* fade out (0.5s) */\n  100% {\n    opacity: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
